module.exports = __webpack_public_path__ + "static/media/jobFinder.47e94ec2.svg";